// extracted by mini-css-extract-plugin
module.exports = {"trailResult":"PageUITrailResult_trailResult__5MJq_","withInsights":"PageUITrailResult_withInsights__o4pCQ","insights":"PageUITrailResult_insights__44iRo"};